import { render } from "./FishListItem.vue?vue&type=template&id=a6b8dca4&scoped=true&ts=true"
import script from "./FishListItem.vue?vue&type=script&lang=ts"
export * from "./FishListItem.vue?vue&type=script&lang=ts"

import "./FishListItem.vue?vue&type=style&index=0&id=a6b8dca4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b8dca4"]])

export default __exports__